module.exports = __webpack_public_path__ + "media/v2/components/blocks/IconGame/shared/img/survivor/new_touchdawn-3d0094eefdd59cd57373b520d31560af.svg";